import {
  PricingResponse,
  AvailabilityResponse,
  CampaignsResponse,
  CancelCampaignRequest,
  CancelCampaignResponse,
  SubmitCampaignRequest,
  SubmitCampaignResponse,
} from "@/types/api";
import { apiHeaders, apiUrl } from "@/utils/access.utils";

const requestHeaders = apiHeaders();

export const fetchPricing = async (
  dealerId: string,
): Promise<PricingResponse> => {
  const response = await fetch(apiUrl(dealerId, "pricing"), {
    method: "GET",
    credentials: "include",
    headers: requestHeaders,
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch pricing: ${response.status}`);
  }

  return response.json();
};

export const fetchAvailability = async (
  dealerId: string,
  limit: number,
): Promise<AvailabilityResponse> => {
  const url = `${apiUrl(dealerId, "availability")}?limit=${limit}`;
  const response = await fetch(url, {
    method: "GET",
    credentials: "include",
    headers: requestHeaders,
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch availability: ${response.status}`);
  }
  return response.json();
};

export const fetchDealerCampaigns = async (
  dealerId: string,
  campaignStatus: string,
  limit: number,
): Promise<CampaignsResponse> => {
  const params = new URLSearchParams();
  params.append("campaignStatus", campaignStatus);
  params.append("limit", limit.toString());

  const url = `${apiUrl(dealerId, "campaigns")}?${params.toString()}`;

  const response = await fetch(url, {
    method: "GET",
    credentials: "include",
    headers: requestHeaders,
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch campaigns: ${response.status}`);
  }
  return response.json();
};

export const cancelCampaign = async (
  dealerId: string,
  payload: CancelCampaignRequest,
): Promise<CancelCampaignResponse> => {
  const response = await fetch(apiUrl(dealerId, "campaigns"), {
    method: "PATCH",
    credentials: "include",
    headers: requestHeaders,
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw new Error(`Failed to cancel campaign: ${response.status}`);
  }
  return response.json();
};

export const submitCampaign = async (
  dealerId: string,
  payload: SubmitCampaignRequest,
): Promise<SubmitCampaignResponse> => {
  const response = await fetch(apiUrl(dealerId, "campaigns"), {
    method: "POST",
    credentials: "include",
    headers: requestHeaders,
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw new Error(`Failed to submit campaign: ${response.status}`);
  }
  return response.json();
};
